import React from "react";
import { Button, Container } from "reactstrap";
import * as _ from "lodash";

import ButtonHelper from "../../../helpers/ButtonHelper";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";

import Filters from "../_components/Filters";
import useExport from "../_hooks/useExport";
import useReport from "../_hooks/useReport";
import PreviewPDF from "../../../helpers/previewPDF";
import UnitsLineBar from "../_components/UnitsLineBar";
import OperatorLineBar from "../_components/OperatorLineBar";

import "react-datepicker/dist/react-datepicker.css";
import GraphTitle from "../_components/GraphTitle";

const unitReportName = "graficaPasajerosPorUnidadReport";
const operatorReportName = "graficaPasajerosPorOperadorReport";

const unitColumns = [
  {
    id: "counter",
    name: "#",
    selector: (row) => row.counter,
    sortable: true,
    width: "70px",
  },
  {
    id: "no",
    name: "Unidad",
    selector: (row) => row.number,
    sortable: true,
  },
  {
    id: "Pasajeros",
    name: "Pasajeros",
    selector: (row) => row.totalPasajeros,
    sortable: true,
  },
];

const operatorColumns = [
  {
    id: "counter",
    name: "#",
    selector: (row) => row.counter,
    sortable: true,
    width: "70px",
  },
  {
    id: "no",
    name: "Operador",
    selector: (row) => row.fullname,
    sortable: true,
  },
  {
    id: "Pasajeros",
    name: "Pasajeros",
    selector: (row) => row.totalPasajeros,
    sortable: true,
  },
];

const PassengersGraph = () => {
  const {
    items,
    routes,
    filters,
    branches,
    validation,
    reportName,
    isUnitReport,
    isLoadingReport,
  } = useReport({
    unitReportName,
    operatorReportName,
  });

  const {
    chartRef,
    modalPdf,
    fileName,
    setModalPdf,
    isDownloadingGraph,
    isDownloadingReport,
    handleDownloadGraph,
    handleDownloadReport,
  } = useExport({
    filters,
    reportName,
    isUnitReport,
    fileNamePrefix: "pasajeros-por",
  });

  const title = `Pasajeros por ${isUnitReport ? "unidad" : "operador"}`;
  const columns = isUnitReport ? unitColumns : operatorColumns;

  document.title = title;

  return (
    <React.Fragment>
      <div className="page-content chart-report">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle={title}
              columns={columns}
              items={items}
              pending={isLoadingReport}
              config={{}}
              filters={{}}
              setFilters={() => {}}
              filterInp={false}
              pagination={false}
            >
              <div className="mb-3">
                <ButtonHelper
                  reportButons
                  addButon={false}
                  actionReportButon={handleDownloadReport}
                  isDownloadingReport={isDownloadingReport}
                />
              </div>
              <Filters
                routes={routes}
                branches={branches}
                validation={validation}
              />
              <div className="col-md-12 text-end">
                {isUnitReport && (
                  <Button
                    size="sm"
                    color="primary"
                    onClick={handleDownloadGraph}
                    disabled={isDownloadingGraph}
                    tittle="Descargar grafica"
                  >
                    {isDownloadingGraph ? (
                      <i className="bx bx-hourglass bx-spin font-size-16 align-middle"></i>
                    ) : (
                      <i className="fas fa-download"></i>
                    )}
                  </Button>
                )}
              </div>
              {items.length && !isLoadingReport ? (
                <div className="col-md-12">
                  <GraphTitle
                    title="Gráfica de pasajeros por"
                    validation={validation}
                    branches={branches}
                  />
                  {isUnitReport ? (
                    <UnitsLineBar
                      yKey="totalPasajeros"
                      label="Pasajeros"
                      data={items}
                      chartRef={chartRef}
                    />
                  ) : (
                    <OperatorLineBar
                      yKey="totalPasajeros"
                      label="Pasajeros"
                      data={items}
                      chartRef={chartRef}
                    />
                  )}
                </div>
              ) : null}
            </DataTableHelper>
          </div>
        </Container>
      </div>
      {modalPdf.show && (
        <PreviewPDF
          title={title}
          modalPdf={modalPdf}
          setModalPdf={setModalPdf}
          fileName={`${fileName}.pdf`}
        />
      )}
    </React.Fragment>
  );
};

export default PassengersGraph;
